var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDesktopLicense(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 74,
    height: 58,
    viewBox: "0 0 74 58",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1017",
    "data-name": "Group 1017",
    transform: "translate(-488 -20)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_478",
    "data-name": "Rectangle 478",
    width: 74,
    height: 58,
    rx: 6,
    transform: "translate(488 20)",
    fill: "#efefef"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_189",
    "data-name": "Group 189",
    transform: "translate(359.22 -279.77)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "microsoft",
    transform: "translate(144 306.839)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1485",
    "data-name": "Path 1485",
    d: "M272,20.56h20.56V1.371A1.371,1.371,0,0,0,291.189,0H272Z",
    transform: "translate(-248.699)",
    fill: "#4caf50"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1486",
    "data-name": "Path 1486",
    d: "M20.56,20.56V0H1.371A1.371,1.371,0,0,0,0,1.371V20.56Z",
    fill: "#f44336"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1487",
    "data-name": "Path 1487",
    d: "M20.56,272H0v19.189a1.371,1.371,0,0,0,1.371,1.371H20.56Z",
    transform: "translate(0 -248.699)",
    fill: "#2196f3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1488",
    "data-name": "Path 1488",
    d: "M272,272v20.56h19.189a1.371,1.371,0,0,0,1.371-1.371V272Z",
    transform: "translate(-248.699 -248.699)",
    fill: "#ffc107"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesktopLicense);
export default __webpack_public_path__ + "static/media/desktopLicense.50e25d6aacbde8bf1ca9c79a4ae038ef.svg";
export { ForwardRef as ReactComponent };